import React from 'react';
import { Typography, Image, Row, Col, Divider } from 'antd';
import { styles } from '../../../styles';
import RelatedBlog from './RelatedBlogs';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog4() {
  const matches = useMediaQuery('(min-width: 768px)');

  
  return (
    <>
    <Row style={styles.navLinks}>        
      <p><Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ Martin Odeegard’s injury been a blessing in disguise for The Arsenal or is it Arsenal’s misfortune?<span></span></p>
    </Row>
    <Row justify="center">
      <Col xs={24} sm={22} md={20} lg={16}>

        <div
        style={styles.blogContainer}
        >
          <Typography>
            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            Has <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/martin-odegaard/profil/spieler/316264">Martin Odeegard’s</a> injury been a blessing in disguise for The <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a> or is it Arsenal’s misfortune? 
            </Title>
            <Paragraph style={styles.blogParagraph}>
            <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a> Captain Martin Odegaard has been injured for a couple of games now and he is yet to seen back onto the pitch to captain the Arsenal. <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/martin-odegaard/profil/spieler/316264">Martin Odeegard’s</a> Injury Has Forced Arsenal to Be Different with Leandro Trossard coming in for the top-flight games missed by Martin Odegaard, as well as the <a href="https://koostream.live/fixtures/league/UEFA%20Champions%20League">Champions League</a> win over Paris Saint-Germain this week and came on as a sub in the away game at Southampton contributing heavily towards Arsenals third goal scored by Saka. 
            </Paragraph>

          <Image
            preview={false}
              src="https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/blog2.webp" // Replace with a relevant image URL
              alt="Arsenal Captain Martin Odegaard"
              style={{ borderRadius: '8px', width: '75%', margin: '10px' }}
            />

            <Title level={4} style={styles.blogHeading}>What Odeegard brings to <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a>?</Title>
            <Paragraph style={styles.blogParagraph}>
            <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/martin-odegaard/profil/spieler/316264">Martin Odeegard’s</a> injury had seemed to effect Arsenals Free Flowing football style as he acts as a Bridge between the Arsenal defense and the Arsenal attack. His exceptional technical ability and immaculate close control allows him to play between lines and create chances on the half turn for the front three playing in front of him, Odeegard’s Game play often compared to that of <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/mesut-ozil/profil/spieler/35664">Mesut Ozil</a> when playing between the lines, He may not yet be upto the level of Mesut however the trajectory is similar and Odeegard in fact he gives more to the team than Mesut did considering Martins build up play alongside His midfield compatriots and the defensive work he puts in. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            To consistently win back balls in the final third and in fact he is only second to Bukayo Saka in winning back the ball the most times in the oppositions final third for <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a> in the year 2024. <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/martin-odegaard/profil/spieler/316264">Martin Odeegard</a> has without a doubt been one of the most influential and looked up to player in Arsenal’s dressing room which in fact mirrors the reason to why he was made Arsenal’s captain in the first place. 
            </Paragraph>

            <Title level={4} style={styles.blogHeading}>Impact of Odeegards injury</Title>
            <Paragraph style={styles.blogParagraph}>
            However, as games have gone by <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal’s</a> reliability on Odeegard seems to have been diminishing which in fact not a bad thing, it actually forced Arteta to play a different style and improvise in between matches to get results. Ødegaard’s absence forced Arteta to adapt Arsenal’s tactics. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Without their main playmaker, <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a> relied on more pragmatic approaches, often opting for a double-pivot in midfield with Declan Rice and Thomas Partey. The likes of Calafiori and timber have also had the chance to bring about their A game.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Both Calafiori and timber have the ability to comfortably play as either tradional full backs or as inverted full backs <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a> has had to defend more than usual in absence of Martin Odeegard This adjustment has helped Arsenal become more defensively solid, as the team focused on retaining possession, breaking up opposition attacks, and launching swift counter-attacks. 
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            The tactical shift highlighted <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal’s</a> ability to adjust their approach to different types of games, showcasing the squad’s versatility. This tactical flexibility will be useful in the long run, especially in high-stakes matches where the team needs to be adaptable.
            </Paragraph>

            <Divider></Divider>

            <Title level={4} style={{...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
              Read More Below
            </Title>
            <div style={{paddingRight: '10px'}}>
              <RelatedBlog excludedId={4}></RelatedBlog>
            </div>

            <BlogFooter />
          </Typography>
        </div>
      </Col>
    </Row>
    </>
  );
}

